<template>
  <div class="learning-stats">
    <!-- PC版: インライン表示 -->
    <div class="learning-stats__desktop d-none d-lg-flex align-items-center">
      <div
        class="stats-item"
        @click="goToWatchHistory"
        title="総視聴時間"
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z" fill="#4CAF50"/>
        </svg>
        <span class="stats-value">{{ formattedWatchDuration }}</span>
      </div>
      <div class="stats-divider"></div>
      <div
        class="stats-item"
        @click="goToWatchHistory"
        title="視聴本数"
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8 5v14l11-7z" fill="#9C27B0"/>
        </svg>
        <span class="stats-value">{{ watchCount }}本</span>
      </div>
      <div class="stats-divider"></div>
      <div
        class="stats-item"
        @click="goToWatchHistory"
        title="総コメント数"
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z" fill="#2196F3"/>
        </svg>
        <span class="stats-value">{{ totalCommentCount }}</span>
      </div>
      <div class="stats-divider"></div>
      <div
        class="stats-item"
        @click="goToWatchHistory"
        title="総ヒトコト数"
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20 2H4c-1.11 0-2 .89-2 2v18l4-4h14c1.11 0 2-.89 2-2V4c0-1.11-.89-2-2-2zm0 14H6l-2 2V4h16v12z" fill="#FF9800"/>
        </svg>
        <span class="stats-value">{{ totalHitokotoCount }}</span>
      </div>
    </div>

    <!-- スマホ版: シンプルなアイコン形式 -->
    <div class="learning-stats__mobile d-lg-none">
      <!-- オーバーレイ: 外側をタップしたら閉じる -->
      <div
        v-if="isExpanded"
        class="stats-badge__overlay"
        @click="closeExpand"
      ></div>
      
      <div
        class="stats-badge"
        :class="{ 'is-expanded': isExpanded }"
      >
        <div class="stats-badge__icon" @click="toggleExpand">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 3L1 9l4 2.18v6L12 21l7-3.82v-6l2-1.09V17h2V9L12 3zm6.82 6L12 12.72 5.18 9 12 5.28 18.82 9zM17 15.99l-5 2.73-5-2.73v-3.72L12 15l5-2.73v3.72z" fill="#1c1c1e"/>
          </svg>
        </div>
        <transition name="fade">
          <div v-if="isExpanded" class="stats-badge__content" @click.stop>
            <div class="stats-badge__item">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z" fill="#4CAF50"/>
              </svg>
              <span>{{ formattedWatchDuration }}</span>
            </div>
            <div class="stats-badge__item">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 5v14l11-7z" fill="#9C27B0"/>
              </svg>
              <span>{{ watchCount }}本</span>
            </div>
            <div class="stats-badge__item">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M20 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z" fill="#2196F3"/>
              </svg>
              <span>{{ totalCommentCount }}</span>
            </div>
            <div class="stats-badge__item">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M20 2H4c-1.11 0-2 .89-2 2v18l4-4h14c1.11 0 2-.89 2-2V4c0-1.11-.89-2-2-2zm0 14H6l-2 2V4h16v12z" fill="#FF9800"/>
              </svg>
              <span>{{ totalHitokotoCount }}</span>
            </div>
            <div class="stats-badge__link" @click="goToWatchHistory">
              学びの記録へ →
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-facing-decorator'

export type LearningStatistics = {
  totalWatchDuration: number
  watchCount: number
  totalCommentCount: number
  totalHitokotoCount: number
}

@Component
export default class LearningStats extends Vue {
  @Prop({ default: null }) statistics: LearningStatistics | null
  
  isExpanded = false

  get formattedWatchDuration(): string {
    if (!this.statistics) {
      return '0分'
    }
    
    const totalSeconds = this.statistics.totalWatchDuration
    const hours = Math.floor(totalSeconds / 3600)
    const minutes = Math.floor((totalSeconds % 3600) / 60)
    
    if (hours > 0) {
      return `${hours}時間${minutes}分`
    } else {
      return `${minutes}分`
    }
  }

  get watchCount(): number {
    return this.statistics?.watchCount || 0
  }

  get totalCommentCount(): number {
    return this.statistics?.totalCommentCount || 0
  }

  get totalHitokotoCount(): number {
    return this.statistics?.totalHitokotoCount || 0
  }

  toggleExpand() {
    this.isExpanded = !this.isExpanded
  }

  closeExpand() {
    this.isExpanded = false
  }

  goToWatchHistory() {
    this.$router.push({ name: 'WatchHistory' })
    this.isExpanded = false
  }
}
</script>

<style lang="scss" scoped>
.learning-stats {
  &__desktop {
    gap: 8px;
    padding: 6px 12px;
    background: #f8f9fa;
    border-radius: 20px;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
      background: #e9ecef;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    }

    .stats-item {
      display: flex;
      align-items: center;
      gap: 5px;
      cursor: pointer;

      svg {
        flex-shrink: 0;
      }

      .stats-value {
        font-size: 13px;
        font-weight: 600;
        color: #1c1c1e;
        white-space: nowrap;
      }
    }

    .stats-divider {
      width: 1px;
      height: 14px;
      background: #dae5ea;
      margin: 0 2px;
    }

    @media (max-width: 1199px) {
      padding: 5px 10px;
      
      .stats-item {
        gap: 4px;
        
        svg {
          width: 14px;
          height: 14px;
        }
        
        .stats-value {
          font-size: 12px;
        }
      }
    }
  }

  &__mobile {
    position: relative;

    .stats-badge {
      position: relative;
      z-index: 100;

      &__overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.1);
        z-index: 99;
      }

      &__icon {
        width: 32px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        position: relative;
        z-index: 100;
        transition: transform 0.2s, opacity 0.2s;

        &:active {
          transform: scale(0.9);
          opacity: 0.7;
        }

        svg {
          filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1));
        }
      }

      &.is-expanded &__icon {
        opacity: 0.8;
      }

      &__content {
        position: absolute;
        top: 40px;
        right: -8px;
        background: white;
        border-radius: 12px;
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
        padding: 16px;
        min-width: 200px;
        z-index: 101;
        border: 1px solid rgba(0, 0, 0, 0.08);

        &::before {
          content: '';
          position: absolute;
          top: -7px;
          right: 16px;
          width: 14px;
          height: 14px;
          background: white;
          transform: rotate(45deg);
          border-top: 1px solid rgba(0, 0, 0, 0.08);
          border-left: 1px solid rgba(0, 0, 0, 0.08);
        }
      }

      &__item {
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 10px 8px;
        font-size: 15px;
        font-weight: 600;
        color: #1c1c1e;
        border-radius: 6px;

        &:not(:last-child) {
          margin-bottom: 2px;
        }

        svg {
          flex-shrink: 0;
        }
      }

      &__link {
        margin-top: 12px;
        padding: 10px;
        font-size: 14px;
        color: #2196F3;
        text-align: center;
        border-top: 1px solid #eef2f4;
        cursor: pointer;
        font-weight: 600;

        &:hover {
          background: #f8f9fa;
          border-radius: 6px;
        }
      }
    }
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.2s, transform 0.2s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}
</style>

